import { TreeNode } from '../types';

export const flattenTreeForDisplay = (
  roots: TreeNode[],
  expandedIds: Set<string>
): TreeNode[] => {
  const result: TreeNode[] = [];

  const traverse = (nodes: TreeNode[], currentDepth = 0) => {
    nodes.forEach((node) => {
      result.push({
        ...node,
        depth: currentDepth,
      });

      if (expandedIds.has(node.id) && node.children?.length) {
        traverse(node.children, currentDepth + 1);
      }
    });
  };

  traverse(roots);
  return result;
};
